import React from 'react'
import { OrganizationDropdown } from './header-organization-dropdown';
import { MemberDropdown } from './header-member-dropdown';
import { NavItem } from './header-nav-item';
import { useSelector } from 'react-redux'
import auth from '../../utils/auth';
import { Loader } from '../loader';
import { LoginButton } from '../buttons';

const AccountDropdown = ({small, account, profile}) => {
  const { checkIfVerified, checkIfOfficial, getAccountTypeId } = auth()
  const accountTypeId = getAccountTypeId(account)

  if (checkIfOfficial(accountTypeId)) {
    return <NavItem>
      <OrganizationDropdown small={small}/>
    </NavItem>
  }
  else if (checkIfVerified(accountTypeId)) {
    return <NavItem>
      <MemberDropdown small={small}/>
    </NavItem>
  }
}

const AuthButton = ({ small }) => {
  const status = useSelector(state => state.account.status)
  const account = useSelector(state => state.account.data)
  const { getAccountTypeId } = auth()
  const accountTypeId = getAccountTypeId(account)
  const { isLoggedIn } = useSelector(state => state.account)

  return <React.Fragment>
    {
      status === 'loading' &&
      <div className="ml-8">
        <Loader />
      </div>
    }
    {
      status !== 'loading' && (
        isLoggedIn && accountTypeId !== false ? (
          <AccountDropdown small={small} account={account}/>
        ) : (
          <LoginButton small={small} />
        )
      )
    }
  </React.Fragment>
}

export { AuthButton }
